import { useState, Fragment } from 'react';
import ComponentDropdown from '../../UI/ComponentDropdown';
import { useSectionComponents } from './InputHelpers';
import { useAppComponent } from './inputBuilder';
import { Vertical } from 'packages/radiant-react/layout';
import Separator from '../../UI/Separator';
import { useVariable } from '../../../context/ThemeContext';
import styles from '../styles.module.scss';
import { isAiMode } from 'utils';

export const VariablesContent = () => {
  const { state: releaseVariables } = useVariable();
  const component = useAppComponent();

  const itemData = useSectionComponents(releaseVariables, component);
  const [currentIndex, setCurrentIndex] = useState<string[]>([]);

  const renderDropdown = (item: any) => {
    if (item.title === 'Advanced') {
      return <>{item.component}</>;
    }
    return (
      <ComponentDropdown
        id={item.id}
        title={item.title}
        setCurrentIndex={setCurrentIndex}
        currentIndex={currentIndex}
      >
        {item.component}
      </ComponentDropdown>
    );
  };

  return (
    <div className={styles['variables-content-wrapper']}>
      {!isAiMode() && (
        <Separator orientation="horizontal" color="var(--rd-sys-color-border-subtle)" />
      )}
      <Vertical className={styles['list-wrapper']}>
        <div className={styles['main-list']}>
          {itemData &&
            itemData.map((item, index) => {
              return (
                <Fragment key={item?.id || index}>
                  {!item?.isHidden && renderDropdown(item)}
                  {currentIndex.includes(item?.title) && (
                    <Separator
                      orientation="horizontal"
                      color="var(--rd-sys-color-border-subtle)"
                      style={{ margin: '16px 0px' }}
                    />
                  )}
                </Fragment>
              );
            })}
        </div>
      </Vertical>
    </div>
  );
};
